<template>
  <div class="page__compare" :key="`${packageProjectSlugById}`">
    <b-modal
      id="modal-help"
      title="Pomoč"
      size="xl"
      scrollable
      centered
      ok-only
      ok-title="Zapri"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <div v-html="project.intro_text"></div>
      <div v-if="project.intro_img">
        <img
          :src="`${helperImgPath}/${project.intro_img}`"
          class="img-fluid d-block mx-auto mt-4"
          :alt="project.title"
        />
      </div>
    </b-modal>
    <h4 class="title pt-4 pb-4 mb-md-4 text-center bg-primary text-white">
      {{ project.matchup_title }}
      <b-button
        size="sm"
        v-b-modal.modal-help
        class="mr-5 float-right btn-soft-primary"
        variant="light"
      >
        <font-awesome-icon icon="question-circle" />
      </b-button>
    </h4>
    <section class="d-flex align-items-center justify-content-center">
      <div class="container-fluid">
        <div class="row" v-if="isSending && loading">
          <div class="col-12 text-center">
            <b-spinner
              class="m-5"
              label="Busy"
              variant="info"
              style="width: 5rem; height: 5rem"
            ></b-spinner>
          </div>
        </div>
        <div v-else>
          <div class="compare position-relative">
            <!-- TODO: Change variable horizontal to your own variable -->
            <div
              class="page__compare__grid"
              :class="{ horizontal: horizontal }"
              :style="getGridColumnWidth()"
              ref="pageGrid"
              v-on:load="handleScroll"
              v-on:scroll.passive="handleScroll"
            >
              <template v-if="project.compare">
                <!-- We have to slice the compareFields array, because it starts with empty object 'col_0' -->
                <div
                  v-for="(field, fieldIndex) in matchup?.compareFields?.slice(
                    1,
                    matchup?.compareFields?.length
                  )"
                  :key="`item-${fieldIndex}`"
                  class="card-compare"
                >
                  <div
                    class="d-flex flex-column justify-content-center align-items-center"
                  >
                    <!-- We add +1 to itemIndex, because compareFields starts with empty object 'col_0' -->
                    <b-badge
                      pill
                      variant="dark"
                      class="card-compare__badge"
                      v-if="field?.card_index"
                      >{{ headerBadge(field?.card_index) }}</b-badge
                    >
                    <CardCompareTitle
                      v-bind:attrib="{
                        field: field,
                        label: field?.label,
                      }"
                      v-bind:imgPath="imgPath"
                    />
                    <!-- <pre>{{itemIndex + 1}}</pre> -->
                    <!-- <pre>{{matchup.compareFields[itemIndex + 1]}}</pre> -->
                  </div>
                  <div class="card-compare__divider" />
                  <!-- We have to slice the compareFields array, because it starts with empty object 'col_0' -->
                  <template v-for="(item, itemIndex) in matchup.compareItems">
                    <div
                      :key="`stat-${itemIndex}`"
                      class="d-flex flex-column align-items-center mt-0"
                    >
                      <CardCompareLabel
                        v-bind:attrib="item[field.key]"
                        v-bind:imgPath="imgPath"
                      />
                      <CardCompare
                        v-bind:attrib="item[field.key]"
                        v-bind:imgPath="imgPath"
                      />
                    </div>
                    <div
                      :key="`separator-${itemIndex}`"
                      class="card-compare__divider"
                    />
                  </template>
                  <div class="d-flex justify-content-center align-items-center">
                    <!-- We add +1 to itemIndex, because compareFields starts with empty object 'col_0' -->
                    <b-button
                      @click="chooseWinner(getMatchupCardById(field.id))"
                      class="d-flex px-4"
                      variant="primary"
                    >
                      <font-awesome-icon icon="thumbs-up" class="text-white" />
                    </b-button>
                  </div>
                </div>
              </template>
              <template v-else>
                <div v-for="card in matchup.cards" :key="card.id">
                  <CardData
                    v-if="card.attr_json"
                    :attribs="JSON.parse(card.attr_json)"
                    :imgPath="imgPath"
                    @vote="chooseWinner(card)"
                  />
                </div>
              </template>
            </div>
            <div
              class="page__compare__fade-out"
              :style="`opacity: ${fadeOutOpacity};`"
            >
              <!-- <font-awesome-icon icon="arrow-right" /> -->
            </div>
          </div>
          <!-- <div v-else>
						<div
							:class="`row d-flex align-items-stretch justify-content-center row-cols-${
								matchup.cards ? matchup.cards.length : 1
							}`"
						>
							<div v-for="card in matchup.cards" v-bind:key="card.id">
								<div v-if="card.attr_json"> -->
          <!--new cards -->
          <!-- <div
										class="
											col
											p-1
											animate__animated animate__flipInY animate__faster
										"
									>
										<b-card class="shadow-md border-0" no-body>
											<CardData
												v-bind:attribs="JSON.parse(card.attr_json)"
												v-bind:imgPath="imgPath"
											/>
											<template #footer>
												<div class="text-center">
													<b-button
														variant="primary"
														@click="chooseWinner(card)"
														class="mx-auto"
													>
														<font-awesome-icon icon="thumbs-up" />
													</b-button>
												</div>
											</template>
										</b-card>
									</div> -->
          <!-- /new cards -->
          <!-- </div>
								<div v-else> -->
          <!-- old cards -->
          <!-- <b-card class="blog d-inline-block shadow" no-body>
										<b-card-body>
											<b-list-group
												flush
												v-for="(attr, index) in card.attributes"
												v-bind:key="index"
											>
												<b-list-group-item
													v-if="attr.attr_type === 'text'"
													class="px-2"
												>
													{{ attr.label }}:
													<br />
													<span class="font-weight-bold">{{ attr.value }}</span>
												</b-list-group-item>
												<b-list-group-item
													v-else-if="attr.attr_type === 'bool'"
													class="px-2"
												>
													{{ attr.label }}
													<br />
													<font-awesome-icon
														:icon="
															attr.value == 1 ? 'thumbs-up' : 'thumbs-down'
														"
														:class="
															attr.value == 1 ? 'text-success' : 'text-danger'
														"
													/>
												</b-list-group-item>
												<b-list-group-item
													v-else-if="attr.attr_type === 'int'"
													class="px-2"
												>
													{{ attr.label }}
													<br />
													<h5>
														<b-badge pill variant="dark">
															{{ attr.value | formatNumber }}
														</b-badge>
													</h5>
												</b-list-group-item>
											</b-list-group>
											<b-link @click="chooseWinner(card)">
												<b-img
													:src="`${imgPath}${card.image}`"
													fluid-grow
													class="
														animate__animated
														animate__bounceIn
														animate__faster
														animate__delay-1s
													"
												/>
											</b-link>
										</b-card-body>
										<b-card-footer class="text-center">
											<b-button variant="success" @click="chooseWinner(card)"
												>Favorit</b-button
											>
										</b-card-footer>
									</b-card> -->
          <!-- /old cards -->
          <!-- </div>
							</div>
						</div>
					</div> -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import "animate.css";
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
moment.locale("en");
import CardData from "@/components/CardData.vue";
import CardCompare from "@/components/CardCompare.vue";
import CardCompareLabel from "@/components/CardCompareLabel.vue";
import CardCompareTitle from "@/components/CardCompareTitle.vue";
export default {
  components: {
    CardData,
    CardCompare,
    CardCompareLabel,
    CardCompareTitle,
  },
  filters: {
    formatNumber: function(value) {
      return new Intl.NumberFormat("sl-SI").format(value);
    },
  },
  data() {
    return {
      isSending: false,
      loading: true,
      flipped: false,
      cellhover: false,
      cellCounter: [],
      timer: {
        started: "",
        finished: "",
        duration: "",
      },
      helperImgPath: `${this.$store.state.api.url}/uploads/${this.$store.state.api.currentProject.id}/help_images`,
      fadeOutOpacity: 1,
      // TODO: Change this to your own variable
      horizontal: false,
    };
  },
  computed: {
    ...mapGetters({
      imgPath: "api/getImgPath",
      project: "api/getCurrentProject",
      currentPackage: "api/getCurrentPackage",
      quizProgress: "api/getQuizProgress",
      matchup: "api/getCurrentMatchup",
      respondentId: "api/getRespondentId",
      packageProjects: "api/getPackageProjects",
      packageProjectsOrderList: "api/getPackageProjectsOrderedList",
      lastProjectOrder: "api/getHighestPackageProjectOrder",
      currentProjectOrder: "api/getPackageCurrentProjectOrder",
      packageProjectSlugById: "api/getPackageProjectSlug",
      nextPackageProjectSlug: "api/getNextPackageProjectSlug",
      projectFinished: "api/isProjectFinished",
      projectSequences: "api/projectSequences",
      randomIdealMatchups: "api/randomIdealMatchups",
      getMatchupCardById: "api/getMatchupCardById",
    }),
    cardJSON() {
      return this.matchup.cards.map((card) => JSON.parse(card.attr_json));
    },
  },

  watch: {},
  created() {
    if (!this.project) {
      this.$store.dispatch("api/fetchProject", this.$route.params.projectSlug);
    }
  },
  mounted() {
    this.startTimer();
    this.whatToShow();
    // Set the opacity of fade scrolling element
    this.handleScroll({ srcElement: this.$refs.pageGrid });
  },
  methods: {
    getGridColumnWidth() {
      const numOfColumns = this.matchup?.compareFields?.length - 1;
      let columnWidth = 40;
      if (numOfColumns === 3) {
        columnWidth = 33;
      } else if (numOfColumns < 3) {
        columnWidth = 50;
      }
      // return `grid-template-columns: repeat(auto-fill, calc(${columnWidth}vw - 1rem));`
      return `grid-template-columns: repeat(auto-fill, calc(${columnWidth}% - 1rem));`;
      // ''
    },
    mapRange(value, low1, high1, low2, high2) {
      return low2 + ((high2 - low2) * (value - low1)) / (high1 - low1);
    },
    handleScroll(e) {
      const scrollableWidth =
        e.srcElement.scrollWidth - e.srcElement.clientWidth;
      const scroll = e.srcElement.scrollLeft;
      this.fadeOutOpacity = this.mapRange(
        scroll,
        scrollableWidth - 32,
        scrollableWidth,
        1,
        0
      );
    },
    onRowHover(item, index) {
      console.log(item);
      console.log(index);
    },
    chooseWinner: function(card) {
      let projectSlug = this.$route.params.projectSlug;
      let packageId = this.currentPackage.id ? this.currentPackage.id : "";

      this.StopTimer();

      this.isSending = true;

      let resultData = {
        project_id: this.project.id,
        respondent_id: this.respondentId,
        matchup_id: this.matchup.id ? this.matchup.id : null,
        matchup_length: this.project.sequences
          ? this.matchup.sequence.matchup_length
          : this.matchup.matchup_length,
        sequence_id: this.project.sequences ? this.matchup.sequence.id : null,
        selected_card_import_id: card.card_id,
        selected_card_id: card.id,
        time_to_answer: this.timer.duration,
        is_ideal: this.project.sequences ? true : false,
        is_random:
          this.project.sequences && this.project.custom_order ? false : true,
        package_id: packageId,
      };

      if (!this.matchup.id) {
        resultData.displayed_cards = {
          order_1: this.matchup.card1_import_id,
          order_2: this.matchup.card2_import_id,
          order_3: this.matchup.card3_import_id
            ? this.matchup.card3_import_id
            : null,
          order_4: this.matchup.card4_import_id
            ? this.matchup.card4_import_id
            : null,
        };
      }

      return new Promise((resolve, reject) => {
        axios({
          url: `${this.$store.state.login.url}/api/project/slug/${projectSlug}/results/new`,
          headers: {
            Authorization: `Bearer ${this.$store.state.login.token}`,
            "Content-Type": "application/json",
          },
          data: JSON.stringify(resultData),
          method: "POST",
        })
          .then((response) => {
            // proceed or finished?
            if (this.projectFinished) {
              if (this.currentPackage) {
                this.nextPackageProject();
              } else {
                // this is just a project
                this.$router.push({
                  name: "Finish",
                  params: {
                    projectSlug: this.project.random_slug,
                  },
                });
              }
            } else {
              this.addProgress();
              this.whatToShow();

              // give it a little time out ...

              setTimeout(
                function() {
                  this.isSending = false;
                  this.timer.started = moment();
                }.bind(this),
                1000
              );

              resolve(response);
            }
          })
          .catch((err) => {
            this.isSending = false;
            this.$bvToast.toast(err.message, {
              title: "Something went wrong ... ",
              autoHideDelay: 5000,
            });
            reject(err);
          });
      });
    },
    startTimer: function() {
      setTimeout(() => {
        this.flipped = true;
        this.timer.started = moment();
      }, 500);
    },
    StopTimer: function() {
      this.timer.finished = moment();
      this.timer.duration = this.timer.finished.diff(
        this.timer.started,
        "seconds"
      );
    },

    addProgress: function() {
      // add quiz progress
      this.$store.commit("api/quizAddProgress");

      if (this.project.sequences) {
        // ideal matchups with set order
        if (this.project.custom_order) {
          if (
            this.matchup.sequence.sequence_length == this.currentMatchupOrder
          ) {
            this.$store.commit("api/addSequenceOrder");
            this.$store.commit("api/resetMatchupOrder");
          } else {
            this.$store.commit("api/addMatchupOrder");
          }
        } else {
          this.$store.commit("api/addMatchupOrder");
        }
      } else {
        this.$store.commit("api/addMatchupOrder");
      }
    },

    whatToShow: function() {
      // did the user enter his data?
      if (this.respondentId) {
        // does the project have ideal sequences & matchups?
        if (this.project.sequences) {
          // custom order of matchups in sequence?
          if (this.project.custom_order) {
            this.$store
              .dispatch(
                "api/fetchProjectIdealOrderedMatchup",
                this.project.random_slug
              )
              .then(() => {
                this.loading = false;
              });
          }
          // random order in ideal matchups?
          else {
            // do we already have all sequences and matchups?
            if (!this.randomIdealMatchups) {
              this.$store
                .dispatch(
                  "api/fetchRandomSequencesMatchups",
                  this.project.random_slug
                )
                .then(() => {
                  this.$store
                    .dispatch(
                      "api/fetchProjectIdealRandomMatchup",
                      this.project.random_slug
                    )
                    .then(() => {
                      this.loading = false;
                    });
                });
            } else {
              this.$store
                .dispatch(
                  "api/fetchProjectIdealRandomMatchup",
                  this.project.random_slug
                )
                .then(() => {
                  this.loading = false;
                });
            }
          }
        }
        // no ideal sequences, just take random project matchup
        else {
          this.$store
            .dispatch("api/fetchRandomProjectMatchup", this.project.random_slug)
            .then(() => {
              this.loading = false;
            });
        }
      } else {
        // rediredct user to enter his data

        if (this.currentPackage) {
          this.$router.push({
            name: "Package",
            params: {
              packageSlug: this.currentPackage.slug,
            },
          });
        } else {
          this.$router.push({
            name: "DataEnter",
            params: {
              projectSlug: this.project.random_slug,
            },
          });
        }
      }
    },
    nextPackageProject: function() {
      if (this.nextPackageProjectSlug) {
        // update current project
        this.$store.dispatch("api/fetchProject", this.nextPackageProjectSlug);

        this.$store.commit("api/resetPackageProject");

        // reload with current project
        this.$router.push({
          name: "IntroPagePackage",
          params: {
            // at this point the project was already refreshed?
            projectSlug: this.project.random_slug,
            packageSlug: this.currentPackage.slug,
          },
        });
      } else {
        this.$router.push({
          name: "PackageFinish",
          params: {
            packageSlug: this.currentPackage.slug,
          },
        });
      }
    },
    headerBadge: function(cardIndex) {
      switch (cardIndex) {
        case 1:
          return "A";
        case 2:
          return "B";
        case 3:
          return "C";
        case 4:
          return "D";
        default:
          return "";
      }
    },
  },
};
</script>
<style></style>
